import { api } from '../../../../api';
import { restaurantTable } from '../../../../config/api';
import { AllTablesDTO } from '../model/types';

export const getAllTablesRequest = (restaurantId: number) =>
  api.get<AllTablesDTO[]>(`${restaurantTable}/${restaurantId}`);
